export default __webpack_public_path__ + "static/media/sample-profile.eae1431c.svg";